import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import "./MediaPhoto.scss";
import {
    fetchQualificationMedias,
    resetQualificationMedias
} from "../../../../../../creators/tagModerations.qualidifcation.medias";
import DraftContentReader from "../../../../../components/editor/DraftContentReader";
import createLink from "../../../../../../libs/createLink";
import {Link} from "react-router-dom";

import ReactivityTagIa from "../ReactivityTagIa/ReactivityTagIa";
import ReactivityTags from "../ReactivityTags/ReactivityTags";
import Swipeable from "../../../Components/Swipeable/Swipeable";
import history from "../../../../../../libs/history";
import {apiUrl} from "../../../../../../libs/api";
import {LoadingBar} from "../../../../../components/Loader";
import LikeBtn from "../../../../../components/Like/LikeBtn";
import {Button} from "../../../../../components/Button";
import Report from "../../../../../components/Report";
import {contentRawToText} from "../../../../../../libs/helper";
import ViewMore from "../../../../../components/ViewMore";
import {reportMedia} from "../../../../../../creators/report";



class MediaPhoto extends Component {
    constructor(props) {
        super(props);
        this.listParentsIa = ['temperature', 'genre'];
        this.classGender = [
            '',
            'gender-1',
            'gender-2',
            'gender-3',
            'gender-3',
            'gender-3',
            'gender-6',
        ];
        this.classBorderGender = [
            '',
            'gender-border-1',
            'gender-border-2',
            'gender-border-3',
            'gender-border-3',
            'gender-border-3',
            'gender-border-6',
        ];
        this.listGender = [
            '',
            'Homme',
            'Femme',
            'Couple',
            'Couple',
            'Couple',
            'Travesti',
        ];
        this.categoryParentSlug = _.get(this.props.currentCategory,'parents[0].slug');
        this.isIa = ['temperature', 'genre'].includes(this.categoryParentSlug);
        this.setTimeOut = null;
        this.state = {
            currentIndex : 0,
            currentMedia : {},
            currentMediaCategory : this.props.currentCategory?._id
        }
        this.props.resetQualificationMedias();
        this.getMedias();
        this.handleConfirmed = this.handleConfirmed.bind(this);
        this.handleDeclined = this.handleDeclined.bind(this);
        this.skipGender = this.skipGender.bind(this);
        this.nextMedia = this.nextMedia.bind(this);
        this.handleReport = this.handleReport.bind(this);

    }

    componentWillUnmount() {
        this.props.resetQualificationMedias();
        clearTimeout(this.setTimeOut);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.qualificationMediasInitialized !== this.props.qualificationMediasInitialized && this.props.qualificationMediasInitialized){
            if(_.get(this.props.qualificationMedias,'[0].media')){
                this.setState({currentMedia : this.props.qualificationMedias[0].media, currentIndex : 0});
            }
        }
        if(this.props.qualificationMediasInitialized && prevProps.qualificationMedias.length !== this.props.qualificationMedias.length){
            let delai = moment(this.props.qualificationMediasLockedUntil).diff(moment(), 'milliseconds');
            this.updateTimeOut(delai);
        }
    }

    updateTimeOut(delay = 0){
        clearTimeout(this.setTimeOut);
        if(delay > 0){
            this.setTimeOut = window.setTimeout(()=>{
                history.push(this.props.goBackUrl);
            }, delay);
        }
    }

    getMedias(more = false){
        this.props.fetchQualificationMedias({categoryId : this.props.currentCategory?._id, more}, more);
    }

    nextMedia(){
        let currentIndex = this.state.currentIndex + 1;
        let qualificationMediasTotal = this.props.qualificationMedias.length || 0;

        if(_.get(this.props.qualificationMedias,`[${currentIndex}].media`)){

            this.setState({currentIndex, currentMedia : this.props.qualificationMedias[currentIndex].media, currentMediaCategory : this.props.currentCategory?._id}, ()=>{
                if((qualificationMediasTotal - 2) === currentIndex ){
                    this.getMedias(true);
                }
            });
        }
        else{
            window.setTimeout(()=>{
                this.setState({currentIndex, currentMedia : {}, currentMediaCategory : this.props.currentCategory?._id});
            },50)

        }
    }

    handleConfirmed(){
        let currentIdModeration = _.get(this.props.qualificationMedias,`[${this.state.currentIndex}]._id`);
        let data = {};
        if(this.isIa){
            if(this.state.currentMediaCategory === "n/a"){
                this.skipGender();
            }
            else{
                data = {
                    currentCategory : this.state.currentMediaCategory
                }
                this.updateIa(currentIdModeration, data);
            }

        }
        else{
            data = {
                currentCategory : this.state.currentMediaCategory,
                isConfirmed:true
            }
            this.updateTag(currentIdModeration, data);
        }

        this.nextMedia();

    }

    handleDeclined(){
        let currentIdModeration = _.get(this.props.qualificationMedias,`[${this.state.currentIndex}]._id`);
        let data = {};
        if(this.isIa){
            /*data = {
                currentCategory : this.state.currentMediaCategory
            }
            this.updateIa(currentIdModeration, data);*/
            if(this.state.currentMediaCategory === "n/a"){
                this.skipGender();
            }
            else{
                data = {
                    currentCategory : this.state.currentMediaCategory
                }
                this.updateIa(currentIdModeration, data);

            }
        }
        else{
            data = {
                currentCategory : this.state.currentMediaCategory,
                isConfirmed:false,
            }
            this.updateTag(currentIdModeration, data);
        }

        this.nextMedia();
    }

    skipGender(){
        let currentIdModeration = _.get(this.props.qualificationMedias,`[${this.state.currentIndex}]._id`);
        let data = {
            currentCategory : this.props.currentCategory?._id
        }
        this.skipTag(currentIdModeration, data);


        //this.nextMedia();
    }

    updateIa(id = null, data = {}){
        apiUrl.patch(`/tag-moderations/qualifications/update-ia/${id}`, data).then(response=>{

        });
    }

    updateTag(id = null, data = {}){
        apiUrl.patch(`/tag-moderations/qualifications/update-tag/${id}`, data).then(response=>{

        });
    }
    skipTag(id = null, data = {}){
        apiUrl.patch(`/tag-moderations/qualifications/skip-gender/${id}`, data).then(response=>{

        });
    }

    handleReport(message){
        this.props.reportMedia(this.state.currentMedia._id, {message});
    }


    render() {
        let currentMedia = {...this.state.currentMedia};

        let currentGender = _.get(currentMedia,'owner.profile.gender') || 0;

        return (
            <div id="tag-moderations-qualification-medias">
                <style>
                    {`
                     header,#footer,.alert-bar{display: none !important;}
                    `}
                </style>
                {!this.props.qualificationMediasInitialized ? (
                    <LoadingBar />
                ) : null}
                {this.props.qualificationMediasInitialized && !currentMedia._id ? (
                    <div className={"media"}><div className={"toback"} onClick={()=> history.push(this.props.goBackUrl)}>Retour</div><span className={"text-danger"}>Aucun Media</span></div>
                ) : null}
                {this.props.qualificationMediasInitialized && currentMedia._id ? (
                    <div className={"media"}>
                        <div className={"reactivity"}>
                            <div className={"toback"} onClick={()=> history.push(this.props.goBackUrl)}>Retour</div>
                            <div className={"thumbnail-likes"}>
                                <LikeBtn
                                    key={currentMedia._id}
                                    parentId={currentMedia._id}
                                    isLiked={currentMedia.isLiked}
                                    likeType={"medias"} />
                                <Report
                                    key={`report_${currentMedia._id}`}
                                    _id={currentMedia._id}
                                    kind={"medias"}
                                    type={"button"}
                                    handleReport={this.handleReport}
                                    title={currentMedia.title}/>
                            </div>
                            {/*<div className={"thumbnail-comments"}><Icon type={"comments-o"} /> {currentMedia.count.comment} reactions</div>*/}
                        </div>
                        <div className={"media-header"}>
                            <div className={"title"}>
                                <Link className={"username"} to={createLink("userProfile", currentMedia.owner)} >{currentMedia.owner.username}</Link>
                                <span className={"separator"}>></span>
                                <Link className={"album-title"} to={createLink("userAlbum", {...currentMedia.owner, album : {_id : currentMedia.album._id, slug : currentMedia.album.slug}})} >{currentMedia.album.title}</Link>
                                <span className={"separator separator-mobile"}>></span>
                            </div>
                            <div className={"title"}>
                                <Link className={"media-title"} to={createLink("mediaviewerPhoto", {...currentMedia.owner, media : {_id : currentMedia._id, slug : currentMedia.slug}})}>{currentMedia.title}</Link>
                            </div>
                        </div>

                        {this.isIa ? (
                            <div className={`thumbnail ${this.classBorderGender[currentGender]}`}>
                                <div className={`gender ${this.classGender[currentGender]}`}>Profil {this.listGender[currentGender]}</div>
                                <img alt={currentMedia.title} src={`${currentMedia.previewUrl}?height=350`} />
                            </div>
                        ) : (
                            <Swipeable
                                classGender={this.classGender[currentGender]}
                                classBorderGender={this.classBorderGender[currentGender]}
                                labelGender={this.listGender[currentGender]}
                                title={currentMedia.title}
                                previewUrl={currentMedia.previewUrl}
                                handleDeclined={this.handleDeclined}
                                handleConfirmed={this.handleConfirmed}
                            />
                        )}


                        {this.isIa ?
                            <ReactivityTagIa
                                skipGender={this.skipGender}
                                updateCategory={(currentMediaCategory)=>this.setState({currentMediaCategory})}
                                currentMediaCategory={this.state.currentMediaCategory}
                                currentCategory={this.props.currentCategory}
                            /> : <ReactivityTags title={this.props.currentCategory?.title} handleDeclined={this.handleDeclined}  handleConfirmed={this.handleConfirmed} />}

                    </div>
                ) : null}

                {/*<div className={"chose-tags"}>

                </div>*/}
                {this.isIa ? (
                    <div className={"w-100 flex-jc-c"}>
                        {currentMedia._id ? (<Button content={"Continuer"} className={"btn-next"} onClick={() => this.handleConfirmed()}/>) : null}
                    </div>
                ) : null}

                {_.get(currentMedia,"contentRaw") && contentRawToText(currentMedia.contentRaw).length !== 0 ? <div className={"description mt-8"}><ViewMore limit={50}><DraftContentReader contentRaw={currentMedia.contentRaw} /></ViewMore></div> : null}

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        qualificationMedias: state.qualificationMedias.data,
        qualificationMediasInitialized : state.qualificationMedias.initialized,
        qualificationMediasTotal : state.qualificationMedias.total,
        qualificationMediasLoading : state.qualificationMedias.loading,
        qualificationMediasLockedUntil : state.qualificationMedias.lockedUntil || null
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchQualificationMedias,
    resetQualificationMedias,
    reportMedia
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MediaPhoto);